let template = `
<div>
  <h2>Import Status</h2>
  <div class="well well-sm">
    <poll-import-status show-history="true" import-uuid="{{$ctrl.importUuid}}"></poll-import-status>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <a ui-sref="import-wizard.step2({domainUuid: $ctrl.domain.uuid, importUuid: $ctrl.importUuid})" class="btn btn-link btn-block">Re-upload CSV</a>
    </div>
    <div class="col-sm-6">
      <button ng-if="$ctrl.state.startDiffReady() && !$ctrl.state.previewReady()" ng-disabled="$ctrl.state.diffInProgress()" ng-click="$ctrl.state.startImportDiff()" class="btn btn-block btn-primary">{{$ctrl.state.diffInProgress() && 'Analyzing changes...' || 'Analyze changes'}}</button>
      <a ng-if="$ctrl.state.previewReady() && !$ctrl.state.importComplete()" ui-sref="import-wizard.step3({domainUuid: $ctrl.domain.uuid, importUuid: $ctrl.importUuid})" class="btn btn-block btn-primary">View preview of changes</a>
      <a ng-if="$ctrl.state.importComplete()" ui-sref="import-wizard.step5({domainUuid: $ctrl.domain.uuid, importUuid: $ctrl.importUuid})" class="btn btn-block btn-primary">View completed import summary</a>
    </div>
  </div>
</div>
`
export default {
  bindings: {
    importUuid: '@',
    domain: '<'
  },
  controller: [
    'importState',
    '$scope',
    'events',
    function(importState, $scope, events) {
      this.state = importState
      this._refreshCallbackIndex = null

      this.$onInit = function() {
        importState.setImportUuid(this.importUuid)
        this._refreshCallbackIndex = importState.registerCallback(autostartDiff.bind(this))
        importState.setAutorefreshInterval(5000)
        importState.toggleAutorefresh()
      }

      this.$onChanges = function(changesObj) {
        if (changesObj.domain && changesObj.domain.currentValue) {
          $scope.$emit(events.DOMAIN_SELECTED, this.domain)
        }
      }

      function autostartDiff() {
        if (
          importState.previewReady() ||
          importState.diffInProgress() ||
          importState.importComplete()
        ) {
          // unregister ourselves
          this.unregisterRefreshCallback()
        } else if (importState.startDiffReady()) {
          // automatically kick off the import diff and then unregister
          console.log('autostarting diff')
          importState.startImportDiff()
          this.unregisterRefreshCallback()
        }
      }

      this.unregisterRefreshCallback = function() {
        // unregister callback
        if (this._refreshCallbackIndex !== null) {
          importState.unregisterCallback(this._refreshCallbackIndex)
        }
      }

      $scope.$on('$destroy', () => {
        this.unregisterRefreshCallback()
      })
    }
  ],
  template
}
